export const GoBack = ({ hanldeClick, label }) => {

return (<div
    className="text-lg font-bold flex flex-row items-center gap-0"
  >
    <div onClick={hanldeClick} className="cursor-pointer hover:opacity-80">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="size-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.75 19.5 8.25 12l7.5-7.5"
        />
      </svg>
    </div>
    {label}
  </div>);
};